import { MAIN_ROLES } from "config";
import { useAuth } from "context/AuthContext";
import { useParams } from "react-router-dom";
import { useGetProjectPermissionQuery } from "store/slices/apis/projectPermissionSlice";

export const usePermission = (permission) => {
    const { user } = useAuth();
    const { projectId } = useParams();
    
    const projectPermission = useGetProjectPermissionQuery(projectId, { skip: !projectId });
    
    const isAdmin = !!user?.roles?.some((r) => MAIN_ROLES?.includes(r));
    
    if (isAdmin) {
        return true
    } else {

        if (projectId !== undefined) {

            let allPermissions = [];

            if (projectId !== undefined) {
                allPermissions = projectPermission?.data?.data?.modules?.flatMap(mod => mod?.permissions || []);
            }

            // const allPermissions = user?.permission?.flatMap(mod => mod.permissions || []);

            if (!allPermissions) return undefined;

            if (allPermissions?.length > 0) {
                return allPermissions.includes(permission);
            } else {
                return false
            }
        } else {
            return false
        }

    }
};
